import { PATCH_DETAILS, PATCH_INSPECTION_LIST, PATCH_INSPECTION_LIST_ERROR, PATCH_INSPECTION_LIST_SUCCESS, PATCH_LIST, PATCH_LIST_ERROR, PATCH_LIST_SUCCESS, USER_TYPES_LIST, USER_TYPES_LIST_ERROR, USER_TYPES_LIST_SUCCESS, USERS_LIST, USERS_LIST_ERROR, USERS_LIST_SUCCESS } from './constants';

export default function patchdata(state, action) {
	let userTypes = [];
	switch (action.type) {
      
	case PATCH_LIST:
		return { ...state, pending: true };
	case PATCH_LIST_SUCCESS:
		return { ...state, patch_data: action.payload, pending: false };
	case PATCH_DETAILS:
		return { ...state, details: action.payload, pending: false };
	case PATCH_LIST_ERROR:
		return { ...state, error: true, pending: false  };

	case PATCH_INSPECTION_LIST:
		return { ...state, pending: true };
	case PATCH_INSPECTION_LIST_SUCCESS:
		return { ...state, inspection_data: action.payload, pending: false };
	case PATCH_INSPECTION_LIST_ERROR:
		return { ...state, error: true, pending: false };
	case USERS_LIST:
		return { ...state, pending: true };
	case USERS_LIST_SUCCESS:
		return { ...state, users_data: action.payload, pending: false };
	case USERS_LIST_ERROR:
		return { ...state, error: true, pending: false };
	case USER_TYPES_LIST:
		return { ...state, loading: true };
	case USER_TYPES_LIST_SUCCESS:
	
		if (action.payload && action.payload.data && action.payload.data.length > 0) {
			action.payload.data.map( (item) => {
				let data = {};
	
				data.id = item.id ? item.id : 0;
				data.userType = item.userType ? item.userType : '<Not Set>';
				data.createdAt = item.createdAt ? item.createdAt : '';
				data.updatedAt = item.updatedAt ? item.updatedAt : '';
				data.aliasName = item.aliasName ? item.aliasName : '';
	
				return userTypes.push(data);
			});
	
			return { ...state, userTypes: userTypes, loading: false, error: false };
		} else {
			if (action.payload && action.payload.data && action.payload.data.length === 0) {
				return { ...state, userTypes: userTypes, loading: false, error: false };
			} else {
				return { ...state, loading: false, error: true };
			}
		}
	
	case USER_TYPES_LIST_ERROR:
		return { ...state, loading: false, error: true };

      
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}